import script from "./MarkupChip.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkupChip.vue?vue&type=script&setup=true&lang=js"

import "./MarkupChip.vue?vue&type=style&index=0&id=57d50f08&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57d50f08"]])

export default __exports__